import React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();
const Register = () => {
    let history = useHistory();
    const handleSubmit = async () => {
        toast.success("You are Registered");
        history.push('/user/login');
    };
    const mainHeader = {
        width: "100%",
        maxWidth: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
      
    const forms = {
        width: "444px",
        height: "720px",
        padding: "62px 48px",
        border: "1px solid #c2c2c2",
        borderRadius: "15px",
        textAlign: "start",
        fontFamily: "'Noto Sans', sans-serif",
        fontSize: "14px",
        marginBottom: "17px",
        color: "#212121"
    };
      
    const btnOrange = {
        backgroundColor: "#f54336",
        width: "100%",
        color: "#fff",
        borderRadius: "30px",
        marginTop: "10px",
        marginBottom: "10px",
        fontSize: "13px"
    };
      
    const h2 = {
        marginBottom: "17px",
        color: "#212121"
    };
    const formGroup = {
        marginBottom: "10px"
    };
      
    const formControl = {
        paddingTop: "30px",
        paddingLeft: "0",
        paddingBottom: "30px",
        outline: "none",
        border: "none",
        borderBottom: "1px solid #e0e2e6",
        borderRadius: "0px",
        marginTop: "10px",
        opacity: "1",
        "&::focus": {
          borderBottom: "1px solid #f54336",
          outline: "none",
          boxShadow: "none"
        }
    };
    const center = {
        display: "block",
        paddingTop: "20px",
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: '20px'
      };
    return(
        <div>
            <img src={process.env.PUBLIC_URL + "/images/logo_new.png"} width="220" height="100" alt="logo" style={center} />
            <header id="main-header" style={mainHeader}>
                <div className="form" style={forms}>
                <form action="#" className="was-validated">
                    <div className="form-group" style={formGroup}>
                     <h2 style={h2}>Register</h2>
                    </div>
                <div className = "form-group" style={formGroup}>
                    <input  placeholder="Name" id="username" className="form-control" type="text" style={formControl} required/>
                </div>
                <div className = "form-group" style={formGroup}>
                    <input style={formControl} placeholder="Email address"  id="email" className="form-control" type="email" required/>
                </div>
                <div className = "form-group" style={formGroup}>
                    <input style={formControl} placeholder="Address" id="address" className="form-control" type="address" required/>
                </div>
                <div className = "form-group" style={formGroup}>
                    <input style={formControl}  placeholder="Phone number" id="contact" className="form-control" type="contact"/>
                </div>
                <div className = "form-group" style={formGroup}>
                    <input style={formControl} placeholder="Location" id="location" className="form-control" type="location"/>
                </div>
                <div className = "form-group" style={formGroup}>
                    <input style={formControl} placeholder="New Password" id="password" className="form-control" type="password"/>
                </div>
                <div className = "form-group" style={formGroup}>
                    <input style={formControl} placeholder="Confirm Password" id="password2" className="form-control" type="password"/>
                </div>
                <div>
                <button style={btnOrange} onClick={handleSubmit} className="btn btn-orange">Submit</button>
                </div>
              <div className="form-group" style={formGroup}></div>
              <div className="form-group" style={formGroup}>
              <p className="">
                  Already have an account?
                  <a href="/CloudCart-Preview/#/user/login">
                    {" "}
                    Login
                  </a>
                </p>
        </div>
    </form>
    </div>
    </header>
    </div>
    );
};
export default Register;